import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  EDUCATION_PLACE,
  EDUCATION_PLACE_ALL,
  EDUCATION_PLACE_CREATE,
  EDUCATION_PLACE_DELETE,
  EDUCATION_PLACE_LIST,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const educationPlace = createAsyncThunk(
  EDUCATION_PLACE,
  async (params: PayloadCreatorParams<`${typeof API.EDUCATION_PLACE}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.educationPlace(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const educationPlaceCreate = createAsyncThunk(
  EDUCATION_PLACE_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.EDUCATION_PLACE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.educationPlaceCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const educationPlaceDelete = createAsyncThunk(
  EDUCATION_PLACE_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.EDUCATION_PLACE}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.educationPlaceDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const educationPlaceList = createAsyncThunk(
  EDUCATION_PLACE_LIST,
  async (params: PayloadCreatorParams<`${typeof API.EDUCATION_PLACE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.educationPlaceList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const educationPlaceAll = createAsyncThunk(
  EDUCATION_PLACE_ALL,
  async (params: PayloadCreatorParams<`${typeof API.EDUCATION_PLACE_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.educationPlaceAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const educationPlaceAllClear = createAction(`${EDUCATION_PLACE_ALL}/clear`)

export const educationPlaceClear = createAction(`${EDUCATION_PLACE}/clear`)

export const educationPlaceListClear = createAction(`${EDUCATION_PLACE_LIST}/clear`)
